/*
* Prepare datetime. Return object with values.
* */
export const formatDateTime = (dateTime) => {
    let dateTimeArr = dateTime.split('T');
    let date = dateTimeArr[0].split('-');
    let time = dateTimeArr[1].split('Z');
    time = time[0].split(':');

    return {
        year: date[0],
        month: date[1] - 1,
        day: date[2],
        hour: time[0],
        minute: time[1],
        second: time[2],
    }
}
